import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CPDetails, CPRemark } from 'src/model/cpDetails';

@Component({
	selector: 'app-view-cp-details',
	templateUrl: './view-cp-details.component.html',
	styleUrls: ['./view-cp-details.component.scss'],
	standalone: false
})
export class ViewCpDetailsComponent implements OnInit {
	private activeModal = inject(NgbActiveModal);
	private restApi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	private sharedService = inject(SharedService);

	@Input() customerId: number;
	@Input() customerCode: string;
	customerRemarks: CPRemark[] = [];

	cpDetails: CPDetails;

	ngOnInit(): void {
		this.getCPDetails(this.customerId);
	}

	getCPDetails(customerId: number) {
		const xhr = this.restApi.getRequest(this.constructApi.getCPCustomerDetails(customerId));

		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					const json = JSON.parse(xhr.responseText);

					this.cpDetails = new CPDetails(
						json.customerID,
						json.additionalInfo,
						json.custAltNumber,
						json.customerCode,
						json.customerIC,
						json.customerName,
						json.debtAmount,
						json.debtTerm,
						json.caseStatus,
						json.charges,
						json.custOccupation,
						json.custStatus,
						json.defaultPhone,
						json.officeAmount,
						undefined,
						json.employeeName
					);
				} else {
					this.sharedService.openAlert('Error! Cannot show details!  ' + JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER);
					this.activeModal.close();
				}
			}
		};
	}

	getCPRemarks(customerId: number) {
		this.customerRemarks = [];
		const xhr = this.restApi.getRequest(this.constructApi.getCPCustomerRemarks(customerId));

		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					const jsonArray = JSON.parse(xhr.responseText);

					if (jsonArray.length > 0) {
						jsonArray.forEach(json => {
							const remark = {
								HandlerName: json.handlerName,
								RemarkDate: new Date(json.remarkDate),
								RemarkDesc: json.remarkDesc,
								RemarkID: json.remarkID
							};

							this.customerRemarks.push(remark);
						});
					}
					this.customerRemarks.sort((a, b) => (a.RemarkDate > b.RemarkDate ? -1 : 1));
				} else {
					this.sharedService.openAlert('Error! ' + JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER);
				}
			}
		};
	}

	closeModal() {
		this.activeModal.close();
	}
}
